<template>
    <div :class="[$style.__header]">
        <div :class="[$style.__logo]" ref="a">
            <img :src="logo" alt="">
        </div>
        <div :class="[$style.__status, parentOnline ?  [$style.__online] : [$style.__offline] ]" >
            <span :class="[$style.__status__text]">Live chat</span>
            <span :class="[$style.__dot]"></span>
        </div>
        <div :class="[$style.__action]">
            <span :class="[$style.__container]">
                <a @click="minimiez()" :class="[isMinimiez ? [$style.__expaned] : [$style.__minimized], $style.__icon, 'material-icons']">{{ isMinimiez ? 'expand_less' : 'expand_more' }}</a>
            </span>
            <span :class="[$style.__container]" >
                <a v-if="isMobile != true" @mousedown="checkMe"  v-dragged.prevent="onDragged"  :class="[$style.__move, $style.__icon, 'material-icons']">open_with</a>
            </span>
            <span :class="[$style.__container]">
                <a @click="confirmExit" :class="[$style.__close, $style.__icon, 'material-icons']">close</a>
            </span>
        </div>
    </div>
</template>

<script>

module.exports = {
    data() {
        return {
            logo: require('@/medias/images/header/logo.png'),
            isMinimiez : this.parentMinimiez,
        }
    },
    props: {
        parentMinimiez: Boolean, 
        parentOnline : Boolean, 
        isMobile : {
            type : Boolean,
            default : false
        }
    },
    methods : {
        minimiez : function() {
            this.isMinimiez = !this.isMinimiez,
            this.$emit('update:parentMinimiez', this.isMinimiez)
            localStorage.setItem("isMinimiez", this.isMinimiez);

        },
        onDragged({ el, deltaX, deltaY, offsetX, offsetY, clientX, clientY, first, last }) {
            var parentMove = { el, deltaX, deltaY, offsetX, offsetY, clientX, clientY, first, last }
            this.$emit('interface', parentMove)
        },

        confirmExit : function () {
            if(this.isMinimiez == true) {
                this.isMinimiez = false;
                this.$emit('update:parentMinimiez', this.isMinimiez)
            }
            this.$emit('parentCloseChatHeader', true)
        },

        cancelExit : function () {
            this.cfmExit = false;
        },

        checkMe : function () {
            this.$emit('parentCheckMe')
        },

        exitsChat : function () {
            Socket.close(this.room);
            console.log('Leave room');
            chathubObject.leaveRoom(this.room, this.token);
            this.$cookies.remove('fpt_livechat');
            this.$router.push('/');
        },
        
    },
    
 
}
</script>

<style scoped module lang="scss">
   
    .__header {
        background: #fff;
        width: 100%;
        height: 43px;
        display: table;
        table-layout: fixed;
        -webkit-box-shadow: -1px 4px 5px 0px rgba(214,214,214,.3);
        -moz-box-shadow: -1px 4px 5px 0px rgba(214,214,214,.3);
        box-shadow: -1px 4px 5px 0px rgba(214,214,214,.3);
        position: absolute;
        top: 0px;
        z-index: 999;
    
        div {
            display: table-cell;
            vertical-align: middle;
        }
        
        .__logo {
            width: 100px;
            text-align: center;
            img {
                height: 23px;
                text-align: center;
            }
        }
        
        .__status {
            width: 113px;
            position: relative;
            text-align: left;
            .__status__text {
                border-radius: 50px;
                padding: 2.5px 11px;
                font-size: 12px;
                font-weight: 400;
                
            }
            .__dot {
                height: 10px;
                width: 10px;
                border: 1px solid #fff;
                border-radius: 50%;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
                border-radius: 50%;
                display: inline-block;
                position: absolute;
                top: 10px;
                left: 63px;
            }
            &.__online {
                .__status__text {
                    background: #6FCF72;
                    color: #fff;
                }
                .__dot {
                    background-color: #239bee;
                }
            }
            &.__offline {
                .__status__text {
                    background: #F1F0F0;
                    color: #9A9A9A;
                }
                .__dot {
                    background-color: #9A9A9A;
                } 
            }
        }

        .__action {
            text-align: right;
            position: relative;
            display: table;
            width: auto;
            height: 100%;
            float: right;
            margin-right: 8px;
            .__container {
                display: table-cell;
                vertical-align: middle;
                padding-top: 5px;
                .__icon {
                    font-size: 22px;
                    color: #8B919A !important;

                    &:hover {
                        color : #007bff !important;
                    }
                    &.__minimized, &.__expaned {
                        font-weight: 500;
                        
                    }
                    &.__move {
                        padding-left: 4px;
                        padding-right: 7px;
                        font-size: 13px;
                    }
                    &.__close {
                        font-weight: 700;
                        font-size: 16px;
                        color: #8B919A;
                        position: relative;
                        top: 1px;
                    }
                    &.__minimized, &.__move, &.__close, &.__expaned {
                        cursor: pointer;
                       
                    }
                    
                }
            }
        }
        
    }
    
    
</style>